import { set, sortBy, map, reject } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchInventoryItemLocationZoneOptions } from '../../../sagas/options/routines';
import {
  addItemLocationZoneOption,
  updateItemLocationZoneOption,
  removeItemLocationZoneOption
} from '../../../actions/options/item-location-zone';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const addOptionHandler = action => ({
  [action.toString()]: (state, { payload: item }) => ({
    ...state,
    all: sortBy('label', [...state.all, item])
  })
});

const updateOptionHandler = action => ({
  [action.toString()]: (state, { payload: item }) => ({
    ...state,
    all: map(option => (option.value === item.id ? item : option), state.all)
  })
});

const removeOptionHandler = action => ({
  [action.toString()]: (state, { payload: value }) => ({
    ...state,
    all: reject({ value }, state.all)
  })
});

export default createReducer(initialState, {
  ...fetchOptionsHandler(fetchInventoryItemLocationZoneOptions),
  ...addOptionHandler(addItemLocationZoneOption),
  ...updateOptionHandler(updateItemLocationZoneOption),
  ...removeOptionHandler(removeItemLocationZoneOption)
});
